import App from '@atlassian/jira-software-reports-overview';
import { createReportPageBootstrap } from '@atlassian/jira-spa-apps-next-gen-reports-page';

// @ts-expect-error - TS2345 - Argument of type 'typeof SoftwareReports' is not assignable to parameter of type 'ComponentType<AppProps>'.
export default createReportPageBootstrap('overview', App);
